// Safe same-origin return paths for `?voltar=` and the interest reopen flag.
import type { CourseKey } from "./types.js"

export const INTEREST_REOPEN_PARAM = "interesse"

/** Returns the path only when it is a same-origin relative path; otherwise null (no open redirect). */
export function safeReturnPath(raw: string | null | undefined): string | null {
  if (!raw) return null
  const path = raw.trim()
  if (path.length === 0 || path.length > 512) return null
  if (!path.startsWith("/")) return null
  if (path.startsWith("//") || path.startsWith("/\\")) return null
  if ([...path].some((ch) => ch.charCodeAt(0) < 0x20)) return null
  return path
}

export function withInterestReopen(path: string): string {
  const [base, hash = ""] = path.split("#", 2)
  const [pathname, search = ""] = base.split("?", 2)
  const params = new URLSearchParams(search)
  params.set(INTEREST_REOPEN_PARAM, "1")
  return `${pathname}?${params.toString()}${hash ? `#${hash}` : ""}`
}

export function withoutInterestReopen(search: string): string {
  const params = new URLSearchParams(search)
  params.delete(INTEREST_REOPEN_PARAM)
  const next = params.toString()
  return next ? `?${next}` : ""
}

export function buildCourseUrl({ courseKey, returnTo }: { courseKey: CourseKey; returnTo?: string | null }): string {
  const safe = safeReturnPath(returnTo)
  return safe ? `/cursos/${courseKey}?voltar=${encodeURIComponent(safe)}` : `/cursos/${courseKey}`
}

export function buildAdoptionFormUrl({
  animalIds,
  returnTo,
  funnelId,
}: {
  animalIds: string[]
  returnTo?: string | null
  funnelId?: string | null
}): string {
  const [first, ...others] = animalIds
  const params = new URLSearchParams()
  if (others.length > 0) params.set("outros", others.join(","))
  const safe = safeReturnPath(returnTo)
  if (safe) params.set("voltar", safe)
  if (funnelId) params.set("funil", funnelId)
  const qs = params.toString()
  return `/candidatura/${encodeURIComponent(first)}${qs ? `?${qs}` : ""}`
}

const ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/

export function parseAnimalIds(first: string | undefined, others: string | null): string[] {
  const ids = [first ?? "", ...(others ? others.split(",") : [])]
  return ids.filter((id) => ID_PATTERN.test(id))
}
